<template>
	<div style="background-color: #eee">
		<v-overlay :value="isLoadingPage">
			<v-progress-circular
				indeterminate
				size="64"
				color="primary"
			></v-progress-circular>
		</v-overlay>

		<template v-if="!isLoadingPage">
			<div class="mb-6">
				<div class="font-weight-bold mb-2 secondary--text">
					REGOLE ISCRIZIONE AL GAME DAY
				</div>
				<div>
					<v-icon color="success">mdi-checkbox-outline</v-icon>
					Puoi iscriverti solo se hai <b>superato la selezione.</b>
				</div>
				<div>
					<v-icon color="success">mdi-checkbox-outline</v-icon>
					<b>Individua il Game Day a cui vuoi iscriverti</b> leggendo data e ora e clicca su “Iscriviti a questo Game Day”.
				</div>
				<div>
					<v-icon color="success">mdi-checkbox-outline</v-icon>
					Iscriviti <b>entro 2 ore</b> prima dell’inizio e <b>segna l’appuntamento</b> sul tuo calendario.
				</div>
				<div>
					<v-icon color="success">mdi-checkbox-outline</v-icon>
					Devi <b>essere in postazione</b> nel giorno e nell’orario stabilito (il Game Day dura meno di 10 minuti!).
				</div>
				<div>
					<v-icon color="success">mdi-checkbox-outline</v-icon>
					Usa un <b>PC con Browser aggiornato</b> (Safari e PC aziendali non sono ammessi).
				</div>
				<div class="mb-2">
					<v-icon color="success">mdi-checkbox-outline</v-icon>
					Devi inviare entro 5 minuti dalla fine del Game Day <b>uno screenshot della prova del click</b> al tuo coordinatore su Telegram.
				</div>
				<div>
					Se ti iscrivi e poi non partecipi, perderai punti in classifica e potresti essere <b>escluso dal vero Click Day. Iscriviti solo se sei sicuro di poter esserci</b>, hai tempo fino a 2h prima dell’inizio del Game Day.
				</div>
			</div>
			
			<div class="section_title mb-6">
				<div>Prossimi Game Day in programma</div>
				<div></div>
			</div>
			<div
				v-if="gamedaysProssimi.length == 0"
				class="font-weight-bold py-8 px-9 my-6"
				style="font-size: 18px; background-color: white"
			>
				Nessun Game Day in programma
			</div>
			<game-day-box-component
				v-else
				v-for="gameday in gamedaysProssimi"
				:key="gameday.gameday_id"
				:gameday="gameday"
				:idCliccatore="idCliccatore"
				:opzioniEsitoGameDay="opzioniEsitoGameDay"
				@reload-gamedays="getGamedays()"
			></game-day-box-component>

			<div class="section_title mb-6">
				<div class="titolo_gameday_passato"
				>
					Game Day passati
				</div>
				<div class="linea_gameday_passato"></div>
			</div>
			<game-day-box-component
				v-for="gameday in gamedaysPassati"
				:key="gameday.gameday_id"
				:gameday="gameday"
				:idCliccatore="idCliccatore"
				:opzioniEsitoGameDay="opzioniEsitoGameDay"
				@reload-gamedays="getGamedays()"
			></game-day-box-component>
		</template>
	</div>
</template>

<script>
export default {
	props: ['idCliccatore'],
	data() {
		return {
			isLoadingPage: false,
			gamedaysPassati: [
				{
					gameday_id: null,
					nome: null,
					data_ora: null,
					data_ora_scadenza_iscrizione: null,
					compenso_vittoria: null,
					punti_gameday_vinto: null,
					punti_gameday_perso: null,
					tempo: null,
					esito_gameday: null,
					cliccatore_iscritto_al_gameday: null,
				},
				// ...
			],
			gamedaysProssimi: [
				{
					gameday_id: null,
					nome: null,
					data_ora: null,
					data_ora_scadenza_iscrizione: null,
					compenso_vittoria: null,
					punti_gameday_vinto: null,
					punti_gameday_perso: null,
					tempo: null,
					esito_gameday: null,
					cliccatore_iscritto_al_gameday: null,
				},
				// ...
			],
			opzioniEsitoGameDay: []
		}
	},

	async created() {
		await this.getGamedays();
	},

	methods: {
		getGamedays() {
			this.isLoadingPage = true;
			const url = this.idCliccatore ? '/clickdayit/gamedays/' + this.idCliccatore : '/clickdayit/gamedays'
			return axios.get(url)
				.then(response => {
					this.gamedaysPassati = response.data.gamedays_passati;
					this.gamedaysProssimi = response.data.gamedays_prossimi;
					this.opzioniEsitoGameDay = response.data.opzioniEsitoGameDay;
					this.isLoadingPage = false;
				})
		},
		
	}
}
</script>

<style lang="scss" scoped>
.section_title {
	background-color: #eee;
	//padding-top: 30px;
	display: flex;
	div {
		width: 50%;
		&.titolo_gameday_passato {
			background-color: #acb5c2;
		}
	}
	:nth-child(1) {
		font-size: 20px;
		font-weight: 700;
		text-align:center;
		background-color: #6D94CD;
		padding: 10px 15px;
		color:white
	}
	:nth-child(2) {
		border-bottom: 5px solid #6D94CD;
		&.linea_gameday_passato {
			border-bottom: 5px solid #acb5c2;
		}
	}
}
//.gameday_passato {
//	background-color: #acb5c2;
//}
</style>